module Client.App

open Elmish
open Elmish.React
open Elmish.Bridge
open ClientModel
open Shared
open Client
open Elmish.Navigation

#if DEBUG
open Elmish.Debug
open Elmish.HMR
#endif


Program.mkProgram init update view
|> Program.withBridgeConfig (
  Bridge.endpoint Remote.socketPath
  |> Bridge.withMapping RC
  |> Bridge.withWhenDown ConnectionLost
)
|> Program.toNavigable Pages.urlParser urlUpdate
#if DEBUG
|> Program.withConsoleTrace
#endif
|> Program.withReactBatched "elmish-app"
#if DEBUG
|> Program.withDebugger
#endif
|> Program.run
